import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_1f422eec-5881-4e5c-967b-75ea88bef889/artifacts/0s733g2d_CaribouStudio.png" 
              alt="Caribou Studio" 
              className="h-10 w-auto"
            />
            <span className="text-xl font-light tracking-wider">CARIBOU STUDIO</span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-sm font-light tracking-wide hover:text-gray-600 transition-colors duration-300"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-sm font-light tracking-wide hover:text-gray-600 transition-colors duration-300"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-sm font-light tracking-wide hover:text-gray-600 transition-colors duration-300"
            >
              Work
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2 bg-black text-white text-sm font-light tracking-wide hover:bg-gray-800 transition-colors duration-300"
            >
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg py-4">
            <div className="flex flex-col space-y-4 px-6">
              <button
                onClick={() => scrollToSection('about')}
                className="text-left text-sm font-light tracking-wide hover:text-gray-600 transition-colors duration-300"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="text-left text-sm font-light tracking-wide hover:text-gray-600 transition-colors duration-300"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('portfolio')}
                className="text-left text-sm font-light tracking-wide hover:text-gray-600 transition-colors duration-300"
              >
                Work
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-left px-6 py-2 bg-black text-white text-sm font-light tracking-wide hover:bg-gray-800 transition-colors duration-300 w-fit"
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
